import { PlainDatatypes } from '../../../datatype/Datatype';
import { createConditionOperator } from '../IConditionOperator';

export const ConditionOperatorInType = createConditionOperator({
  code: 'in',
  label: 'in',
  description: 'È uno di',
  args: [
    {
      type: 'referenceValue',
      isArray: true,
    },
  ],
  allowsField: field => PlainDatatypes.includes(field.type),
  compare(value: any, [list]: [any[]]) {
    if (list == null) return false;
    return list.includes(value);
  },
});
